import { Flex, FlexProps } from '@chakra-ui/react';
import { ButtonLink, Icon } from '~/ui-components';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { useLocalization } from '~/framework';

type PageBarInternals = 'direction' | 'backgroundColor' | 'borderBottomRadius' | 'align';

type PageBarProps = Omit<FlexProps, PageBarInternals> & {
   backLabel?: string;
   backHref?: string;
   useNativeBackNavigation?: boolean;
};

export function PageBar({
   children,
   backHref,
   backLabel,
   useNativeBackNavigation,
   ...props
}: PageBarProps) {
   const { _js } = useLocalization();
   if (!backLabel) {
      backLabel = _js('Back');
   }
   return (
      <Flex
         backgroundColor="gray.100"
         borderBottomRadius="md"
         height="50px"
         justifyContent="space-between"
         {...props}
      >
         <ButtonLink
            href={backHref}
            useNativeBackNavigation={useNativeBackNavigation}
            leftIcon={<Icon type={faArrowLeft} />}
            height="auto"
            borderTopRadius={0}
            borderRightRadius={0}
            variant="solid"
         >
            {backLabel}
         </ButtonLink>
         <Flex align="center">{children}</Flex>
      </Flex>
   );
}
